import { render } from "./post-smtp-banners.vue?vue&type=template&id=9759029c&scoped=true"
import script from "./post-smtp-banners.vue?vue&type=script&lang=js"
export * from "./post-smtp-banners.vue?vue&type=script&lang=js"

import "./post-smtp-banners.vue?vue&type=style&index=0&id=9759029c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9759029c"]])

export default __exports__